export enum UiStatesEnum {
  state = 'state',
  diamonds = 'diamonds',
  avatarUrl = 'avatarUrl',
  characterName = 'characterName',
  isOffline = 'isOffline',
  chatId = 'chatId'
}
